import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { LanguageService } from '../service/language-service/language.service';
import { Subject, takeUntil } from 'rxjs';

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
  language: string = 'es';
  private readonly destroy$ = new Subject<void>();
  // Definiciones de textos en inglés
  private englishTexts = {
    itemsPerPageLabel: 'Rows per page:',
    nextPageLabel: 'Next page',
    previousPageLabel: 'Previous page',
    firstPageLabel: 'First page',
    lastPageLabel: 'Last page',
  };

  // Definiciones de textos en español
  private spanishTexts = {
    itemsPerPageLabel: 'Filas por página:',
    nextPageLabel: 'Siguiente página',
    previousPageLabel: 'Página anterior',
    firstPageLabel: 'Primera página',
    lastPageLabel: 'Última página',
  };

  // override itemsPerPageLabel = 'Filas por página:';
  // override nextPageLabel = 'Siguiente página';
  // override previousPageLabel = 'Página anterior';
  // override firstPageLabel = 'Primera página';
  // override lastPageLabel= 'Última página';

  constructor(private languageService: LanguageService) {
    super();
    this.subLanguageConfig();
  }

  subLanguageConfig() {
    this.languageService.getCurrentLang().pipe(takeUntil(this.destroy$))
    .subscribe((lang) => {
      this.language = lang;
      this.updateLabels(this.language);
      this.changes.next(); // Notifica a los componentes que usan este intl que hay cambios
    });
  }

  private updateLabels(language): void {
    const texts = language === 'es' ? this.spanishTexts : this.englishTexts;

    this.itemsPerPageLabel = texts.itemsPerPageLabel;
    this.nextPageLabel = texts.nextPageLabel;
    this.previousPageLabel = texts.previousPageLabel;
    this.firstPageLabel = texts.firstPageLabel;
    this.lastPageLabel = texts.lastPageLabel;
  }

  override getRangeLabel = (
    page: number,
    pageSize: number,
    length: number
  ): string => {
    if (length === 0 || pageSize === 0) {
      // return `0 de ${length}`;
      return this.language === 'es' ? `0 de ${length}` : `0 of ${length}`;
    }
    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    // return `${startIndex + 1}–${endIndex} de ${length}`;
    return this.language === 'es'
      ? `${startIndex + 1}–${endIndex} de ${length}`
      : `${startIndex + 1}–${endIndex} of ${length}`;
  };

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
